// @flow

import _ from "lodash";
import React, { Component } from "react";
import { Button } from "react-bootstrap";
import { compose } from "react-apollo";
import { NavLink } from "react-router-dom";
import { withUser } from "../../data/accounts";

import type {
  //  sessionQueryResult,
  //  extendSessionMutationResult,
  SessionType
} from "../../data/session";

import WithLoadingIndicator from "../../components/WithLoadingIndicator/WithLoadingIndicator";
import TasksResults from "../../components/TasksResults/TasksResults";
import { withExtendSession, withSession } from "../../data/session";
import { withSessionResults } from "../../data/session-results";
import ReactGA from "react-ga";

import "./BreakScreen.css";

// type Props = {
//   projectId: string,
//   accept: () => void,
//   decline: () => void
// } & sessionQueryResult &
//   extendSessionMutationResult;

type Props = Object; // FIXME: Requires extendSessionType

class BreakScreen extends Component<Props> {
  componentDidMount() {
    ReactGA.pageview("Break Screen");
  }

  accept = () => {
    const session = this.session();
    if (!session) {
      throw new Error("Tried to accept without session!");
    }
    const newLimitQuestions = session.limitValue + 5;
    this.props
      .extendSession({
        variables: {
          id: session.id,
          limitValue: newLimitQuestions,
          maxBonusCents: null
        }
      })
      .then(result => {
        console.log("extendSession result", result);
        this.props.sessionData.refetch();
        this.props.accept();
      });
  };

  session(): ?SessionType {
    if (!this.props.sessionData.user) {
      return null;
    }
    return _.first(this.props.sessionData.user.sessions);
  }

  render() {
    const session = this.session();
    if (!session) {
      return <div>No session found.</div>;
    }
    return (
      <div className="BreakScreen">
        <div className="BreakScreen-Title">Nice job!</div>
        <div className="BreakScreen-Message">
          <p>You just completed a block of 5 questions.</p>
        </div>
        <div className="BreakScreen-Controls">
          <Button
            className="BreakScreen-Accept"
            bsSize="large"
            onClick={this.accept}
          >
            Continue
          </Button>
          <a
            className="BreakScreen-Decline"
            href="#exit"
            onClick={(e: Event) => {
              e.preventDefault();
              this.props.decline();
            }}
          >
            Done for now
          </a>
          {this.props.userData.user && this.props.userData.user.email ? null : (
            <div>
              <p>
                <br />
                <NavLink to="/signup" exact activeClassName="active">
                  Sign up
                </NavLink>{" "}
                to save your data.
              </p>
            </div>
          )}
        </div>
        {_.has(this.props, "sessionResultsData.allTasks") && (
          <div className="BreakScreen-Stats-Section">
            <h4>Here's how your recent session is going:</h4>
            <TasksResults
              tasks={this.props.sessionResultsData.allTasks}
              hasObjectiveAnswers={this.props.hasObjectiveAnswers}
            />
          </div>
        )}
      </div>
    );
  }
}

const extendComponent = compose(
  withUser,
  withExtendSession,
  withSession,
  WithLoadingIndicator,
  withSessionResults
);

export default extendComponent(BreakScreen);



// WEBPACK FOOTER //
// ./src/pages/Questions/BreakScreen.js